export const ENV_LIST = ['LIVE', 'LOCAL', 'STAGING']
